module.exports = __webpack_public_path__ + "img/3dstepicon.a85a4750.png";